export class SessionStorageKey {
  public static telemetryData = "telemetryData";
}
